module.exports = __webpack_public_path__ + "img/L3.5f323f90.png";